import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { ConfigFieldOption } from '@/eventConfig/types.ts';
import { useForm } from '@/form/useForm.ts';

export const NameSummaryFormCL = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['name'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const salutationField = s.name.fields.find(({ name }) => name === 'salutation');
  const salutationLabel = translate(salutationField?.label);

  // Options are nested in groups, take them out
  const salutationOptions = (salutationField?.options || [])
    .reduce((acc, curr) => {
      return [...acc, curr, ...(curr?.options || [])];
    }, [] as ConfigFieldOption[])
    .filter(({ value }) => value !== '');

  const salutationValue =
    translate(salutationOptions.find(({ value }) => `${value}` === getFieldValue('salutation'))?.label) ||
    getFieldValue('salutation');

  const rutField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'rut'),
    message: s.dataSummary.requiredMessage!,
  });
  const rutLabel = translate(rutField?.label);

  const firstNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'firstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const firstNameLabel = translate(firstNameField?.label);

  const lastNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'lastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const lastNameLabel = translate(lastNameField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-name'}>
      <h2>{translate(s.dataSummary.titles?.name)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{rutLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('rut')}
          {editMode && <EditDataField field={rutField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{salutationLabel}</div>
        <div className={'value'}>
          {!editMode && salutationValue}
          {editMode && <EditDataField field={salutationField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{firstNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('firstname')}
          {editMode && <EditDataField field={firstNameField!} slideId={'name'} />}
        </div>

        <div className={'label'}>{lastNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('lastname')}
          {editMode && <EditDataField field={lastNameField!} slideId={'name'} />}
        </div>
      </div>
    </div>
  );
};
